module.exports = __webpack_public_path__ + "static/assets/d98fb626fea4e6b0e57dd69cd5def2f0.png";